import { Box } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IButtonsBackground {
  buttonsBackgroundColor?: string;
}

export const ButtonsBackground = ({
  buttonsBackgroundColor,
}: IButtonsBackground) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: isDesktop ? '56px' : '100%',
          bgcolor: buttonsBackgroundColor || 'primary.shade_100',
          bottom: '0',
          left: '0',
          borderBottomRightRadius: '16px',
          borderBottomLeftRadius: '16px',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          bottom: '-75px',
          left: '-50px',
          bgcolor: '#ffffff4d',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          top: '-70px',
          right: '-45px',
          bgcolor: '#ffffff4d',
        }}
      />
    </>
  );
};
